import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4l11.733 16h4.267l-11.733 -16l-4.267 0","key":"svg-0"}],["path",{"d":"M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772","key":"svg-1"}]]

/**
 * IconBrandX
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQteCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCA0bDExLjczMyAxNmg0LjI2N2wtMTEuNzMzIC0xNmwtNC4yNjcgMCIgLz4KICA8cGF0aCBkPSJNNCAyMGw2Ljc2OCAtNi43NjhtMi40NiAtMi40Nmw2Ljc3MiAtNi43NzIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-x
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandX = createReactComponent('outline', 'brand-x', 'BrandX', __iconNode);

export default IconBrandX;